var React = require('react');

function HamburgerClosed (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.6","d":"M2 0C0.89543 0 0 0.895431 0 2H2V0ZM21 0H2V2H21V0ZM23 2C23 0.89543 22.1046 0 21 0V2H23ZM21 4C22.1046 4 23 3.10457 23 2H21V4ZM2 4H21V2H2V4ZM0 2C0 3.10457 0.89543 4 2 4V2H0ZM2 8C0.895431 8 0 8.89543 0 10H2V8ZM21 8H2V10H21V8ZM23 10C23 8.89543 22.1046 8 21 8V10H23ZM21 12C22.1046 12 23 11.1046 23 10H21V12ZM2 12H21V10H2V12ZM0 10C0 11.1046 0.89543 12 2 12V10H0ZM2 18V16C0.89543 16 0 16.8954 0 18H2ZM2 18H0C0 19.1046 0.89543 20 2 20V18ZM21 18H2V20H21V18ZM21 18V20C22.1046 20 23 19.1046 23 18H21ZM21 18H23C23 16.8954 22.1046 16 21 16V18ZM2 18H21V16H2V18Z","fill":"#382E2B"}));
}

HamburgerClosed.defaultProps = {"width":"23","height":"20","viewBox":"0 0 23 20","fill":"none"};

module.exports = HamburgerClosed;

HamburgerClosed.default = HamburgerClosed;
